import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Jackpot } from '@features/games/jackpot/interfaces/jackpot.interface';
import { SvgIconComponent } from 'angular-svg-icon';
import { UserLevelComponent } from '@core/components/user-level/user-level.component';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { JackpotSkinsSliderComponent } from '@features/games/jackpot/jackpot-skins-slider/jackpot-skins-slider.component';
import { ContextMenuService } from '@core/services/context-menu.service';
import { isBotPlayer, stripBotPrefix } from '@core/utils/bot-player.util';
import { BotTagComponent } from '@core/components/bot-tag/bot-tag.component';

@Component({
  selector: 'app-jackpot-round-details-modal',
  templateUrl: './jackpot-round-details-modal.component.html',
  styleUrl: './jackpot-round-details-modal.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, SvgIconComponent, UserLevelComponent, BalanceIconComponent, JackpotSkinsSliderComponent, BotTagComponent],
  host: { class: 'modal-container flex flex-col' },
})
export class JackpotRoundDetailsModalComponent {
  readonly round = input.required<Jackpot>();
  public contextMenuService = inject(ContextMenuService);
  protected readonly isBot = isBotPlayer;
  protected readonly botName = stripBotPrefix;
}
